<template>
  <div>
    <b-overlay :show="overlay" variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="md">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Top: Per Page + Search + Ações -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="mb-0 mr-50">Mostrar</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="mb-0">entradas</label>

              <b-button
                v-b-toggle.cliente-filters
                size="sm"
                variant="outline-primary"
                class="ml-2"
              >
                <feather-icon icon="FilterIcon" />
                <span class="ml-25">Filtros</span>
                <b-badge v-if="activeFiltersCount" variant="primary" pill class="ml-25">
                  {{ activeFiltersCount }}
                </b-badge>
              </b-button>
            </b-col>

            <!-- Search + Buttons -->
            <b-col cols="12" md="8">
              <div class="d-flex align-items-center justify-content-end flex-wrap" style="gap: 6px;">
                <b-input-group class="flex-grow-1" style="min-width: 240px; max-width: 420px;">
                  <b-form-input
                    v-model="searchInputValue"
                    placeholder="Buscar por razão social, CNPJ, código KS, código ERP..."
                    @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" variant="outline-danger" @click="clearSearch">
                      <feather-icon icon="XIcon" />
                    </b-button>
                    <b-button :disabled="overlay" variant="outline-primary" @click="handleSearch">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <!-- Botão único de criação: abre o formulário simplificado -->
                <b-button
                  v-if="$store.getters['preferencias/cadastroClienteAtivo']"
                  variant="primary"
                  @click="$bvModal.show('modal-criar-cliente')"
                >
                  <feather-icon icon="PlusIcon" />
                  <span class="ml-25">Novo</span>
                </b-button>
              </div>
            </b-col>
          </b-row>

          <!-- Chips de filtros aplicados -->
          <div v-if="filterChipsData.length" class="d-flex flex-wrap mt-1" style="gap: 6px;">
            <b-badge
              v-for="chip in filterChipsData"
              :key="chip.key"
              variant="light-primary"
              class="d-inline-flex align-items-center"
            >
              <span>{{ chip.label }}</span>
              <feather-icon
                icon="XIcon"
                size="12"
                class="ml-50 cursor-pointer"
                @click="handleRemoveChip(chip)"
              />
            </b-badge>
          </div>

          <!-- Filtros (collapse) -->
          <b-collapse id="cliente-filters" class="mt-1">
            <b-card border-variant="primary" class="mb-0">
              <b-row>
                <b-col cols="12" md="3" class="mb-1 mb-md-0">
                  <label class="small">Situação</label>
                  <b-form-select v-model="filterSituacao" size="sm">
                    <b-form-select-option value="">Todos</b-form-select-option>
                    <b-form-select-option value="DIGITACAO">Digitação</b-form-select-option>
                    <b-form-select-option value="FINALIZADO">Finalizado</b-form-select-option>
                    <b-form-select-option value="CANCELADO">Cancelado</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mb-1 mb-md-0">
                  <label class="small">Sit. Integração</label>
                  <b-form-select v-model="filterIntegracao" size="sm">
                    <b-form-select-option value="">Todos</b-form-select-option>
                    <b-form-select-option value="INTEGRADO">Integrado</b-form-select-option>
                    <b-form-select-option value="NAO_INTEGRADO">Não Integrado</b-form-select-option>
                    <b-form-select-option value="ERRO">Erro</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mb-1 mb-md-0">
                  <label class="small">Tipo Pessoa</label>
                  <b-form-select v-model="filterTipoPessoa" size="sm">
                    <b-form-select-option value="">Todos</b-form-select-option>
                    <b-form-select-option value="J">Jurídica</b-form-select-option>
                    <b-form-select-option value="F">Física</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col cols="12" md="3">
                  <label class="small">CNPJ/CPF</label>
                  <b-form-input v-model="filterCnpj" size="sm" placeholder="Digite o CNPJ ou CPF" />
                </b-col>
              </b-row>
              <div class="d-flex justify-content-end mt-1" style="gap: 6px;">
                <b-button size="sm" variant="outline-secondary" @click="limparFiltrosDrawer">
                  <feather-icon icon="XIcon" />
                  <span class="ml-25">Limpar</span>
                </b-button>
                <b-button size="sm" variant="primary" @click="aplicarFiltros">
                  <feather-icon icon="CheckIcon" />
                  <span class="ml-25">Aplicar</span>
                </b-button>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <b-table
          ref="refClienteListTable"
          class="position-relative"
          :items="fetchCliente"
          responsive
          :fields="tableColumns"
          primary-key="clienteid"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Nenhum registro encontrado"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Código KS -->
          <template #cell(clienteid)="data">
            <span class="font-weight-bold">{{ data.item.clienteid }}</span>
          </template>

          <!-- Código ERP -->
          <template #cell(clienteiderp)="data">
            <span class="text-muted">{{ data.item.clienteiderp || '—' }}</span>
          </template>

          <!-- CNPJ -->
          <template #cell(clientecnpj)="data">
            {{ data.item.clientecnpj || '—' }}
          </template>

          <!-- Razão Social -->
          <template #cell(clienterazaosocial)="data">
            {{ data.item.clienterazaosocial || '—' }}
          </template>

          <!-- Situação -->
          <template #cell(clientestatus)="data">
            <b-badge :variant="statusVariant(data.item.clientestatus)">
              {{ data.item.clientestatus || '—' }}
            </b-badge>
          </template>

          <!-- Integração -->
          <template #cell(clientesitintegracao)="data">
            <b-badge :variant="data.item.clienteiderp ? 'light-success' : 'light-secondary'">
              {{ data.item.clienteiderp ? 'Integrado' : 'Não Integrado' }}
            </b-badge>
          </template>

          <!-- Ações -->
          <template #cell(actions)="data">
            <div class="d-flex" style="gap: 6px;">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-primary"
                title="Visualizar"
                class="btn-icon"
                size="sm"
                @click="openEditModal(data.item)"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>
              <b-button
                v-if="data.item.clienteiderp === null && data.item.clientestatus === 'DIGITACAO'"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-danger"
                title="Excluir"
                class="btn-icon"
                size="sm"
                @click="openModalDeleteCustomField(data.item)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.of }} entradas
              </span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalCliente"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalCriarCliente @criado="onClienteCriado" />

    <ModalAtt
      idModal="modal-att-cliente"
      titleModal="Visualizar Cliente"
      labelBtnOk="Fechar"
      v-model="dataCliente"
      @cancel="resetFormData()"
    />

    <ModalAdd
      idModal="modal-add-cliente"
      titleModal="Adicionar Cliente"
      labelBtnOk="Salvar"
      v-model="dataCliente"
      @ok="create($event)"
      @cancel="resetFormData()"
    />

    <modal-confirmation
      v-model="isDeleteModal"
      id-modal="modal-delete-cliente"
      title="Deletar Cliente"
      btn-cancel-label="Cancelar"
      btn-ok-label="Sim, deletar"
      @ok="handleRemover(deletedCustomField.clienteid)"
      @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar este cliente?</p>
        </div>
      </template>
    </modal-confirmation>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BOverlay, BCard, BRow, BCol, BTable, BButton, BBadge,
  BFormInput, BFormSelect, BFormSelectOption,
  BInputGroup, BInputGroupAppend, BPagination, BCollapse, VBToggle,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import ModalAtt from '@/views/cadastros/cliente/cliente/list/ModalAtt.vue';
import ModalAdd from '@/views/cadastros/cliente/cliente/add/ModalAdd.vue';
import ModalCriarCliente from '@/views/cadastros/cliente/cliente/list/ModalCriarCliente.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useList from './useList';

export default {
  name: 'ClienteList',
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BBadge,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BCollapse,
    vSelect,
    ModalAtt,
    ModalAdd,
    ModalCriarCliente,
    ModalConfirmation,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        clienteid: null,
        clienteiderp: '',
      },
      searchInputValue: '',
      appliedFilters: {
        situacao: '',
        integracao: '',
        tipoPessoa: '',
        cnpj: '',
      },
    };
  },
  computed: {
    activeFiltersCount() {
      let count = 0;
      if (this.appliedFilters.situacao) count++;
      if (this.appliedFilters.integracao) count++;
      if (this.appliedFilters.tipoPessoa) count++;
      if (this.appliedFilters.cnpj) count++;
      return count;
    },
    filterChipsData() {
      const chips = [];
      if (this.appliedFilters.situacao) {
        chips.push({ key: 'situacao', label: `Situação: ${this.appliedFilters.situacao}` });
      }
      if (this.appliedFilters.integracao) {
        const label = this.appliedFilters.integracao === 'INTEGRADO' ? 'Integrado'
          : this.appliedFilters.integracao === 'NAO_INTEGRADO' ? 'Não Integrado' : 'Erro';
        chips.push({ key: 'integracao', label: `Integração: ${label}` });
      }
      if (this.appliedFilters.tipoPessoa) {
        chips.push({
          key: 'tipoPessoa',
          label: `Tipo: ${this.appliedFilters.tipoPessoa === 'J' ? 'Jurídica' : 'Física'}`,
        });
      }
      if (this.appliedFilters.cnpj) {
        chips.push({ key: 'cnpj', label: `CNPJ: ${this.appliedFilters.cnpj}` });
      }
      return chips;
    },
  },
  methods: {
    applyGlobalSearchQuery() {
      const q = this.$route && this.$route.query ? this.$route.query.q : null;
      if (!q) return;
      const value = Array.isArray(q) ? q[0] : q;
      this.searchInputValue = value;
      this.searchQuery = value;
    },
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Cliente deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataCliente = data;
      this.$bvModal.show('modal-att-cliente');
    },
    resetFormData() {
      this.deletedCustomField = { clienteid: null, clienteiderp: '' };
      this.dataCliente = { clienteid: null, clienteiderp: '' };
      this.isDeleteModal = false;
    },
    chamarRota() {
      this.$router.push({ name: 'apps-pre-cadastro-cliente' });
    },
    onClienteCriado() {
      if (this.$refs.refClienteListTable) {
        this.$refs.refClienteListTable.refresh();
      }
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
    aplicarFiltros() {
      this.appliedFilters = {
        situacao: this.filterSituacao,
        integracao: this.filterIntegracao,
        tipoPessoa: this.filterTipoPessoa,
        cnpj: this.filterCnpj,
      };
      this.$root.$emit('bv::toggle::collapse', 'cliente-filters');
    },
    limparFiltrosDrawer() {
      this.filterSituacao = '';
      this.filterIntegracao = '';
      this.filterTipoPessoa = '';
      this.filterCnpj = '';
      this.appliedFilters = { situacao: '', integracao: '', tipoPessoa: '', cnpj: '' };
    },
    handleRemoveChip(chip) {
      if (chip.key === 'situacao') { this.appliedFilters.situacao = ''; this.filterSituacao = ''; }
      if (chip.key === 'integracao') { this.appliedFilters.integracao = ''; this.filterIntegracao = ''; }
      if (chip.key === 'tipoPessoa') { this.appliedFilters.tipoPessoa = ''; this.filterTipoPessoa = ''; }
      if (chip.key === 'cnpj') { this.appliedFilters.cnpj = ''; this.filterCnpj = ''; }
    },
    statusVariant(status) {
      const map = {
        DIGITACAO: 'light-warning',
        FINALIZADO: 'light-success',
        CANCELADO: 'light-danger',
      };
      return map[status] || 'light-secondary';
    },
  },
  created() {
    this.applyGlobalSearchQuery();
  },
  watch: {
    '$route.query.q': function () {
      this.applyGlobalSearchQuery();
    },
  },
  setup() {
    const dataCliente = ref({ clienteid: null, clienteiderp: '' });

    const {
      perPage,
      currentPage,
      totalCliente,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refClienteListTable,
      fetchCliente,
      overlay,
      create,
      Updated,
      removerData,
      filterSituacao,
      filterIntegracao,
      filterTipoPessoa,
      filterCnpj,
    } = useList();

    return {
      dataCliente,
      perPage,
      overlay,
      currentPage,
      totalCliente,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchCliente,
      tableColumns,
      refClienteListTable,
      Updated,
      create,
      removerData,
      filterSituacao,
      filterIntegracao,
      filterTipoPessoa,
      filterCnpj,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
